module.exports = __webpack_public_path__ + "static/media/confeitaria-duque-caxias-cardapio-menu-ingles-portugues-768x591.7c2977a7.jpg";